import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';
import {BigWinEvents} from '@fantasmagames/slot/src/modules/bigwin/BigWinEvents';
import {BonusGameEvents} from '@fantasmagames/slot/src/modules/bonus/BonusGameEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {InfoEvents} from '@fantasmagames/slot/src/modules/hud/info/InfoEvents';
import {InfoModule} from '@fantasmagames/slot/src/modules/hud/info/InfoModule';
import {InfoView} from '@fantasmagames/slot/src/modules/hud/info/InfoView';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {WinUtils} from '@fantasmagames/slot/src/logic/WinUtils';

export class InfoModuleBasicState extends ModuleState<InfoView, InfoModule> {
	protected _isSpinning: boolean = false;

	public onEnterState(): void {}

	public onLeaveState(): void {}

	protected setupEvents(): void {
		this.on(InfoEvents.UPDATE, this.onUpdate);

		// this.on(WinPresentationEvents.INITIAL_ANIMATION_SKIPPED, this.onInitialWinAnimationSkipped);
		this.on(WinPresentationEvents.INDIVIDUAL_ANIMATION_SKIPPED, this.onWinPresentationStopped);

		this.on(WinPresentationEvents.COUNTUP_FINISHED, this.onWinCountupFinished);
		this.on(WinPresentationEvents.WIN_NUMBER_SHOWN_TO_PLAYER, this.onWinShownToPlayer);
		// onWinInitialWinFinished

		this.on(FlowModuleEvents.NO_WIN, this.onNoWin);

		this.on(BonusGameEvents.BONUS_OUTRO_FINISHED, this.onBonusOutroFinished);
		this.on(BigWinEvents.COUNTUP_FINISHED, this.onBigWinFinished);

		this.on(LogicEvents.INIT_RESPONSE, this.onInitResponse);
		this.on(LogicEvents.SPIN_RESPONSE, this.onSpinResponse);

		this.on(SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onSpinButtonPressed);
		this.on(SpinButtonEvents.SPIN_PRESSED_NOT_ENOUGH_MONEY, this.onSpinButtonPressedNotEnoughMoney);

		this.on(ReelsEvents.ALL_REELS_STOPPED, this.onAllReelsStopped);

		this.on(FlowModuleEvents.WON, this.onWon);

		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);
	}

	public updateBalance(balance: number): void {
		this.view.setBalance(balance);
	}

	public updateBet(): void {
		const bet = this.module.logic.getTotalBet();
		this.view.setBet(bet);
	}

	public updateWin(win: number): void {
		if (!this.module.shownWin && win === 0) {
			this.module.shownWin = true;
			win = this.module.lastWin;

			return;
		}

		this.module.lastWin = win;

		this.view.setWins(win);
	}

	protected onAllReelsStopped(): void {
		this._isSpinning = false;

		this.module.clearWin();
	}

	protected onCanSpin(): void {}

	protected onWon(): void {
		this.module.lastWin = this.module.logic.getWin();
		this.module.shownWin = false;
	}

	protected onSpinResponse(): void {
		this.module.preSpinBalanceUpdate();
		this.module.clearWin();
	}

	protected updateAll(): void {
		const win = this.module.logic.getWin();

		this.updateWin(win);
		this.updateBalance(this.module.logic.currentBalance);
		this.updateBet();
	}

	protected onSpinButtonPressed(): void {
		this._isSpinning = true;
	}

	protected onSpinButtonPressedNotEnoughMoney(): void {
		this.module.clearWin();
	}

	protected onUpdate(): void {
		this.updateAll();
	}

	protected onWinPresentationStopped(): void {
	}

	protected onInitResponse(): void {
		if (this.module.logic.hasRestore) {
			this.updateBalance(this.module.logic.currentBalance - this.module.logic.getWin());
		} else {
			this.updateBalance(this.module.logic.currentBalance);
		}
		this.updateBet();
		this.updateWin(0);
	}

	protected onWinCountupFinished(): void {
		this.updateData();
	}

	protected onWinShownToPlayer(): void {
		this.updateData();
	}

	protected updateData(): void {
		const win = this.module.logic.getSpinWin();

		if (this.shouldUpdateBalance()) {
			this.updateBalance(this.module.logic.currentBalance);
		}

		if (!WinUtils.isBigWin(this.module.logic)) {
			this.updateWin(win);
		}
	}

	protected onWinNumberShownToPlayer(): void {
		const win = this.module.logic.getSpinWin();

		if (this.shouldUpdateBalance()) {
			this.updateBalance(this.module.logic.currentBalance);
		}

		if (!WinUtils.isBigWin(this.module.logic)) {
			this.updateWin(win);
		}
	}

	protected shouldUpdateBalance(): boolean {
		return !this.module.logic.isFreeSpinsJustWon();
	}

	protected onBigWinFinished(): void {
		const win = this.module.logic.getSpinWin();

		if (this.shouldUpdateBalance()) {
			this.updateBalance(this.module.logic.currentBalance);
		}
		this.updateWin(win);
	}

	protected onNoWin(): void {
		this.updateData();
	}

	protected onBonusOutroFinished(): void {
		const win = this.module.logic.getBonusWin();

		this.updateWin(win);
		this.updateBalance(this.module.logic.currentBalance);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/hud/info/states/InfoModuleBasicState.ts